import { Home, MessageCircle, BookOpen } from "lucide-react";
import { NavLink } from "react-router-dom";

const items = [
  { to: "/home", icon: Home, label: "Home", testid: "nav-home" },
  { to: "/chat", icon: MessageCircle, label: "Chat", testid: "nav-chat" },
  { to: "/journal", icon: BookOpen, label: "Journal", testid: "nav-journal" },
];

export default function BottomNav() {
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 inset-x-0 z-40 flex justify-center pb-[max(16px,env(safe-area-inset-bottom))] pt-3 pointer-events-none"
    >
      <div className="pointer-events-auto glass rounded-full px-2 py-2 flex items-center gap-1 shadow-2xl">
        {items.map(({ to, icon: Icon, label, testid }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testid}
            className={({ isActive }) =>
              `flex items-center gap-2 px-4 py-2.5 rounded-full text-sm transition-all ${
                isActive
                  ? "bg-gradient-to-br from-[#eac88a]/25 to-[#a07544]/20 text-[#f8ecd4] shadow-[0_0_20px_rgba(234,200,138,0.2)]"
                  : "text-[#ac9470] hover:text-[#f8ecd4]"
              }`
            }
          >
            <Icon size={18} strokeWidth={1.75} />
            <span className="font-ui">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
